<template>
  <div class="clip">
    <div class="item item1 bg-item homepage">
      <!-- 预览界面 -->
      <div class="ev-content">
        <div class="top">
          <div class="logo" @click="urlto('/')" style="cursor: pointer;">
            <img :src="platform.cut_wclip" alt="" v-if="isColor">
            <img :src="platform.cut_bclip" alt="" v-if=!isColor>
          </div>
          <div class="theme">
            <div class="headright">
              <img class="user-img" :src="info.logo" alt="" v-if="info.logo">
              <img class="user-img" src="../../assets/img/user-icon.png" alt="" v-else>
              <span class="user-name">{{ info.username }}</span>
            </div>
            <el-button class="but theme-cut" @click="addColorHandle">主题切换</el-button>
          </div>
        </div>
        <div class="preview">
          <span class="title">预览界面</span>
          <div class="video">
            <!-- <VideoLogo v-if="endVideo"/> -->
            <VideoLogo />
            <video ref="videoRef" :src="template.url" controls class="video-itself" @ended="videoEnded" v-if="!endVideo"
              :volume="volume"></video>
            <div class="video-text" v-if="isText">
              <div class="video-text-box" v-for="item in dataList" :key="item">
                <p>{{ item }}</p>
              </div>
            </div>
          </div>
          <div class="footer">
            <!-- <el-button class="but" @click="caseVideoHandle"><em class="iconfont icon-shipin-m"></em>案例视频</el-button> -->
            <!-- <el-button class="but" @click="previewHandle"><em class="iconfont icon-chakan"></em>预览</el-button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="item item2">
      <!-- 素材文案 -->
      <div class="top adv-scene bg-item">
        <div class="ev-title">
          <em class="iconfont icon-gengduoneirong"></em>
          <p>素材文案</p>
        </div>
        <div class="ev-content">
          <div class="ev-item">
            <span>视频/图片</span>
            <div style="display: flex;">
              <el-upload class="upload-demo" action="/api/file/upload" :headers="headers" :show-file-list="false"
                :on-change="handleChange" :on-success="fileHandleAvatarSuccess" :before-upload="fileBeforeAvatarUpload"
                :on-error="fileUploadError" multiple accept=".mp4,.mov,.jpg,.png">
                <el-button size="small" :loading="uploading">上传(可多选)</el-button>
                <!-- <div slot="tip" class="el-upload__tip">建议视频大小不超过100MB</div> -->
              </el-upload>
              <el-button size="small" class="but material-library" icon="el-icon-s-grid"
                @click="materialLibrary">从素材库选择</el-button>
            </div>
          </div>
          <div class="ev-item mate-grop" v-if="files.length > 0">
            <el-checkbox-group v-model="checkList" class="mate-grop-box">
              <div class="mate-grop-item" v-for="(item, i) in files" :key="item.file_id">
                <div class="mate-grop-check">
                  <el-button type="text" icon="el-icon-close" class="closebtn" @click="del_video(i)"></el-button>
                </div>
                <div class="mate-grop-video mate-grop-cen" v-if="item.type == 'video'">
                  <video :src="item.url"></video>
                </div>
                <div class="mate-grop-img mate-grop-cen" v-if="item.type == 'image'">
                  <img :src="item.url" alt="">
                </div>
                <div class="mate-grop-txt">
                  <p>{{ item.name }}</p>
                </div>
              </div>
            </el-checkbox-group>
          </div>
          <!-- <div class="scene-box" v-for="(item, index) in tableList" :key="item.id">
            <div class="ev-item">
              <span>{{item.title}}{{index+1}}</span>
              <div>
                <el-input v-model="item.value" class="el-input in-text" type="textarea" autosize @change="textareaChange"></el-input>
              </div>
            </div>
          </div> -->
          <div class="scene-box">
            <el-form label-width="80px">

              <template v-for="group in t_texts">
                <el-form-item :label="item.label" v-for="item in group">
                  <el-input v-model="item.value" :minlength="item.minlength" :maxlength="item.maxlength"
                    :readonly="!item.required" :placeholder="item.required ? '' : '无'"></el-input>
                </el-form-item>
              </template>


              <!-- <el-form-item label="副标题">
                <el-input v-model="editorValue1.title2" @change="textareaChange"></el-input>
              </el-form-item> -->
            </el-form>
          </div>
          <!-- <div class="footer">
            <el-button class="btn but" @click="addHandle"><em class="iconfont icon-wendangxinzeng"></em>加一份文案</el-button>
          </div> -->
        </div>
      </div>
      <!-- 字幕配音 -->
      <div class="subtitle-dub bottom bg-item" style="margin-top: 20px;">
        <div class="ev-title">
          <em class="iconfont icon-tianchongxing-"></em>
          <p>字幕配音</p>
        </div>
        <div class="ev-content">
          <div class="ev-item">
            <el-input id="subtitle1" type="textarea" v-model="subtitle1" :autosize="{ minRows: 5 }" class="subtitle-text"
              ref="textarea" placeholder="按回车分段显示"></el-input>
          </div>
          <div class="ev-item">
            <span>字幕素材</span>
            <div class="subtitle-material">
              <el-button class="but subtitle-btn" @click="subtitleClickHandle"><em
                  class="iconfont icon-zimu"></em>字幕换行</el-button>
              <el-button class="but sele-btn" @click="subtitleClick"><em
                  class="iconfont icon-zimu"></em>从字幕库选择</el-button>
              <!-- <span>选择了<span>{{subtitleListNum}}</span> 个字幕</span> -->
            </div>
          </div>
          <div class="ev-item">
            <span>字幕音量</span>
            <div class="advoice">
              <el-slider v-model="volume" @change="advoiceChange">
              </el-slider>
              <!-- <el-button type="text" class="plus-btn" @click="addVoiceHandle">+</el-button> -->
            </div>
          </div>
          <div class="ev-item">
            <span>字幕声音</span>
            <div class="voice">
              <el-radio-group v-model="voiceRadio">
                <el-radio :label="item.audioCode" v-for="   item    in    audios   ">{{ item.name }}</el-radio>
              </el-radio-group>
              <el-button class="but audition-btn" @click="playAudio()"><em class="iconfont icon-erji1"></em>试听</el-button>
              <el-button class="but audition-btn" @click="stopAudio()"><em class="el-icon-video-pause"></em>结束</el-button>
            </div>
          </div>
          <div class="ev-item">
            <span>字幕颜色</span>
            <div class="subtitleColor">
              <div>
                <span>字</span>
                <el-color-picker v-model="color1" @change="textColorChange"></el-color-picker>
              </div>
              <div>
                <span>框</span>
                <el-color-picker v-model="color2" @change="borderColorChange"></el-color-picker>
              </div>
            </div>
          </div>
          <!-- <div class="subtitle-list" v-if="isSubtitle">
            <el-checkbox-group v-model="subtitleList" @change="subtitleListChange">
              <div class="sub-item">
                <el-checkbox label="1"><el-input type="textarea" v-model="subtitle1" autosize></el-input></el-checkbox>
              </div>
              <div class="sub-item">
                <el-checkbox label="2"><el-input type="textarea" v-model="subtitle2" autosize></el-input></el-checkbox>
              </div>
              <div class="sub-item">
                <el-checkbox label="3"><el-input type="textarea" v-model="subtitle3" autosize></el-input></el-checkbox>
              </div>
            </el-checkbox-group>
          </div> -->
        </div>
      </div>
    </div>
    <div class="item item3">
      <!-- 结束场景 -->
      <!-- <div class="bg-item end-scene">
        <div class="ev-title">
          <em class="iconfont icon-zhaobiaojieshu"></em>
          <p>结束场景</p>
        </div>
        <div class="end-upload ev-content">
          <span>logo</span>
          <div class="end-img">
            <el-button type="text" icon="el-icon-close" class="close" @click="endCloseHandle" v-if="endImageUrl"></el-button>
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="endHandleAvatarSuccess"
              :before-upload="endbeforeAvatarUpload">
              <img v-if="endImageUrl" :src="endImageUrl" class="avatar">
              <div v-else>
                <em class="iconfont icon-shangchuan"></em>
                <p class="up-text">点击上传</p>
              </div>
            </el-upload>
          </div>
          
        </div>
      </div> -->
      <!-- 设置封面 -->
      <div class="bg-item cover">
        <div class="ev-title">
          <em class="iconfont icon-shezhi"></em>

          <p>设置封面</p>
        </div>
        <div class="ev-content cover-con">
          <span></span>
          <div class="sele-mode">
            <div class="img-box">
              <el-button type="text" icon="el-icon-close" class="close" @click="del_cover"
                v-if="coverImageUrl"></el-button>
              <el-upload class="avatar-uploader" action="/api/file/upload" :headers="headers" :show-file-list="false"
                :on-success="coverHandleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-error="uploadError"
                accept=".jpg,.png">
                <img v-if="coverImageUrl" :src="coverImageUrl" class="avatar">
                <div v-else>
                  <em class="iconfont icon-shangchuan"></em>
                  <p class="up-text">点击上传</p>
                </div>
              </el-upload>
            </div>
          </div>

        </div>
      </div>
      <!-- 背景音乐 -->
      <div class="bg-item bg-music">
        <div class="ev-title">
          <em class="iconfont icon-file-music-fill"></em>
          <p>背景音乐</p>
        </div>
        <div class="ev-content bg-con">
          <div class="ev-item">
            <span>选择方式</span>
            <div class="selector-mode">
              <el-radio v-model="seleMode" label="1">在线乐库</el-radio>
              <el-radio v-model="seleMode" label="2">本地音乐</el-radio>
            </div>
          </div>
          <div class="ev-item bg-volume">
            <span>背景音量</span>
            <div class="advoice">
              <el-slider v-model="bgVolume">
              </el-slider>
            </div>
          </div>
          <div class="ev-item">
            <span>选择音频</span>
            <div class="selector-audio">
              <el-radio-group v-model="CheckRadio" v-if="seleMode == '1'">
                <el-radio :label="item.file_id" v-for="item in musics_online" :key="item.file_id">{{ item.file_name
                }}</el-radio>
              </el-radio-group>
              <div v-if="seleMode == '2'">
                <el-radio-group v-model="CheckRadio">
                  <el-radio :label="item.file_id" v-for="item in musics_local" :key="item.file_id">{{ item.file_name
                  }}</el-radio>
                </el-radio-group>
                <div style="display: flex;">
                  <el-upload action="/api/file/upload" :headers="headers" :show-file-list="false"
                    :on-success="musicHandleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-error="uploadError"
                    accept=".mp3">
                    <el-button class="but add-btn"><em class="iconfont icon-tianjia-xue"></em>上传</el-button>
                  </el-upload>
                  <el-button class="but remove-btn" @click="delMusic" style="margin-left: 15px;"><em
                      class="iconfont icon-yichu"></em>删除</el-button>
                </div>
              </div>
              <el-button class="but audition-btn" @click="playMusic"><em class="iconfont icon-erji1"></em>试听</el-button>
              <el-button class="but audition-btn" @click="stopMusic" style="margin-left:17px;">
                <em class="el-icon-switch-button"></em>
                结束</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="compound-box">
        <el-button class="but compound-btn" icon="el-icon-s-help" @click="submit">合成</el-button>
      </div>

    </div>
    <!-- 弹窗-->
    <el-dialog title="图片剪裁" :visible.sync="tailorDialog" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType"
            :info="true" :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox"
            :original="option.original" :autoCrop="option.autoCrop" :fixed="option.fixed"
            :fixedNumber="option.fixedNumber" :centerBox="option.centerBox" :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tailorDialog = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
    <!-- 字幕弹窗 -->
    <el-dialog title="字幕素材" :visible.sync="isSubtitle" class="mat-dialog subtitledialog" width="700px"
      :before-close="handleClose">
      <div class="ev-item mate-grop">
        <div class="mat-select">
          <el-select v-model="product_id" placeholder="请选择" @change="GetSubtitles">
            <el-option v-for="   item    in    products   " :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-table :data="p_subtitles" style="width: 100%"
          :header-cell-style="{ backgroundColor: '#f1f1f1', color: '#000', fontSize: '14px', fontWeight: '400' }" stripe
          ref="multipleTable">
          <el-table-column label="名称" prop="name" width="100px">
          </el-table-column>
          <el-table-column prop="label" label="内容">
          </el-table-column>
          <el-table-column prop="length" label="字数" width="60px">
          </el-table-column>
          <el-table-column label="选择" width="65">
            <template slot-scope="scope">
              <el-radio class="radio" v-model="templateSelection" :label="scope.$index">&nbsp;</el-radio>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn" @click="SeletSubtitles">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 素材弹窗 -->
    <el-dialog title="素材库" :visible.sync="isMaterial" class="mat-dialog" width="700px" :before-close="handleClose">
      <div class="ev-item mate-grop">
        <div class="mat-select">
          <el-select v-model="product_id" placeholder="所属产品" @change="GetPfiles">
            <el-option v-for="   item    in    products   " :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-checkbox-group v-model="mateCheckList" class="mate-grop-box">
          <div class="mate-grop-item" v-for="   item    in    p_files   " :key="item.fileId">
            <div class="mate-grop-check">
              <el-checkbox :label="item"></el-checkbox>
            </div>
            <div class="mate-grop-img mate-grop-cen">
              <img :src="item.url" alt="" v-if="item.type == 'image'">
              <video :src="item.url" alt="" v-if="item.type == 'video' && item.thumb == ''" />
              <img :src="item.thumb" alt="" v-if="item.type == 'video' && item.thumb != ''">
            </div>
            <div class="mate-grop-txt">
              <p>{{ item.name }}</p>
            </div>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn" @click="SeletFiles">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 进度弹窗 -->
    <!-- 试听 -->
    <audio ref="audio" controls id="audio" style="position: fixed;bottom: 10px;left: 10px;" hidden></audio>
    <audio ref="audio2" controls id="audio2" style="position: fixed;bottom: 80px;left: 10px;" hidden></audio>
  </div>
</template>
<script>
import '../../assets/css/clip.css'
import { addColor } from '../../assets/js/addColor.js'
import VideoLogo from "./videoLogo.vue";
import axios from 'axios'
import { getPlatform, getUserinfo } from '../../assets/js/common'
import paltform from '../../assets/js/paltform.json'
export default {
  name: 'clipPage',
  components: { VideoLogo },
  data() {
    return {
      templateSelection: '',
      subtitleData: [],
      // 
      // 主题颜色切换
      addColor,
      saveColor: '',
      isColor: '',
      endVideo: false,
      isText: false,
      textList: [],
      value1: [],
      editorValue1: {
        title: '',
        title2: ''
      },
      editorValue2: {
        title: '',
        title2: ''
      },
      dataList: [],
      // 
      CheckRadio: [],
      // 音量
      volume: 100,
      // 字幕颜色
      color1: '#ffffff',
      color2: '#000000',
      // 选择声音
      voiceRadio: '',
      // 字幕
      subtitleList: [],
      subtitleListNum: 0,
      subtitle1: '',
      subtitle2: '',

      isSubtitle: false,
      // 设置封面
      coverImageUrl: '',
      coverImageId: '',
      checked: '',
      // 结束场景
      endImageUrl: '',
      // 背景音乐
      seleMode: '1',
      // 背景音量
      bgVolume: 15,
      // 背景音乐
      CheckRadio: 0,
      //  在线
      lineCheckRadio: '',
      // 本地
      localityCheckRadio: '',
      // 
      tailorDialog: false,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1270, 622], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      demo: '',
      checkList: [],
      isMaterial: false,
      mateCheckList: [],
      headers: {},
      files: [],
      audios: [],
      musics: [],
      musics_online: [],
      musics_local: [],
      blogo: '',
      wlogo: '',
      product_id: 0,
      products: [],
      p_files: [],
      p_subtitles: [],
      template_code: '',
      uploading: false,
      platform: {},
      t_texts: [],
      info: {},
      playing: false,//配音正在播放
      template: { url: '' }, //模板
    }
  },
  methods: {
    // 主题颜色
    addColorHandle() {
      this.saveColor = localStorage.getItem('theme')
      addColor(false)
      if (this.saveColor == 'black') {
        this.isColor = true
      } else {
        this.isColor = false
      }
    },
    // 预览
    previewHandle() {
      this.isText = !this.isText
      this.dataList = []
      const textList = []
      textList.push(...Object.entries(this.editorValue1), ...Object.entries(this.editorValue2))
      textList.forEach(item => {
        this.dataList.push(item[1])
      })
    },
    // 播放结束
    videoEnded() {
      this.endVideo = true
      this.isText = false
    },
    // 加一份文案
    addHandle() {

    },
    // 音量加
    addVoiceHandle() {
      this.volume++
    },
    // 音量改变
    advoiceChange(value) {
      this.volume = value
    },
    // 获取文字颜色
    textColorChange() {

    },
    // 获取边框颜色
    borderColorChange() {

    },
    // 文案改变的时候
    textareaChange() {
      this.dataList = []
      const textList = []
      textList.push(...Object.entries(this.editorValue1), ...Object.entries(this.editorValue2))
      textList.forEach(item => {
        this.dataList.push(item[1])
      })
      // console.log(this.dataList)
    },
    // 字幕
    subtitleClick() {
      this.isSubtitle = true
    },
    // 
    subtitleListChange() {
      this.subtitleListNum = this.subtitleList.length
    },
    // 设置封面的图片删除
    coverCloseHandle() {

    },
    // 结束场景的图片删除
    endCloseHandle() {

    },
    // 结束场景
    endHandleAvatarSuccess(res, file) {

    },
    endbeforeAvatarUpload(file) {

    },
    // 封面
    // coverHandleAvatarSuccess() {

    // },
    coverBeforeAvatarUpload() {

    },
    materialLibrary() {
      this.isMaterial = true
    },
    caseVideoHandle() {
      this.isText = false
    },
    handleClose(done) {
      done()
    },
    subtitleClickHandle() {
      this.subtitle1 = this.SplitLine(this.subtitle1)
    },
    SplitLine(strOrgin) {
      var arrStr = strOrgin.split("\n"); // 整个文本
      var arrSrt = [];
      var maxLen = 14; // 根据视频宽计算得到
      for (var i = 0; i < arrStr.length; i++) {
        var str = arrStr[i];
        if (str.length > maxLen) {
          if (str.length > maxLen) {
            var lenTmp = 0;
            var cStr = '';
            while (lenTmp < str.length) {
              if (
                str[lenTmp] == ' ' ||
                str[lenTmp] == ',' ||
                str[lenTmp] == '.' ||
                str[lenTmp] == '。' ||
                str[lenTmp] == '，'
              ) {
                if (cStr.length > maxLen * 0.7) {
                  arrSrt.push(cStr.trim());
                  cStr = '';
                } else {
                  cStr += str[lenTmp];
                }
              } else {
                cStr += str[lenTmp];
              }
              lenTmp++;
            }
            if (cStr != '') {
              arrSrt.push(cStr.trim());

            }
          } else {
            arrSrt.push(str.trim());
          }
        } else {
          arrSrt.push(str.trim()); // arrSrt 数组包含了分行后的
        }
      }
      var strLast = arrSrt.join('\n'); // 重新合并数组

      return strLast;
    },
    handleChange(file) {
      return;
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isJPG = testmsg === 'jpg'
      const isPNG = testmsg === 'png'
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
        return
      }
      var reader = new FileReader();
      let data
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要 
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        }
        else {
          data = e.target.result
        }
      }
      console.log(file.url)
      this.$nextTick(() => {
        this.option.img = file.url
        this.tailorDialog = true
      })
    },
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        let fd = new FormData()
        fd.append('file', data)
        this.$http({
          url: `文件上传地址`,
          method: 'post',
          data: fd,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(({ data }) => {
          console.log(data)
          if (data.code === 200) {
            this.inputForm.pic = data.url;  // 返回路径赋值
            this.tailorDialog = false
          } else {
            this.$message.error(data.msg);
          }
        })
      })
    },
    //批量上传成功
    fileHandleAvatarSuccess(res, file) {
      this.$message.closeAll();
      if (res.code == 200) {
        this.$message.success(file.name + " 上传完成");
        this.files.push(res.data);
      } else {
        this.$message.error(file.name + res.msg);
      }
      this.uploading = false;
    },
    fileBeforeAvatarUpload(file) {
      let maxsize = 1024 * 1024 * 512;
      if (file.size > maxsize) {
        this.$message.error("文件太大超过了500M");
        return false;
      }
      this.uploading = true;
    },

    fileUploadError(error, file) {
      this.$message.closeAll();
      this.$message.error(file.name + " 上传失败");
      this.uploading = false;
    },



    beforeAvatarUpload(file) {
      let maxsize = 1024 * 1024 * 512;
      if (file.size > maxsize) {
        this.$message.error("文件太大超过了500M");
        return false;
      }
    },
    uploadError(error, file) {
      this.$message.closeAll();
      this.$message.error(file.name + " 上传失败");
    },
    //上传封面
    coverHandleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.$message.success(file.name + " 上传完成");
        this.coverImageUrl = res.data.url;
        this.coverImageId = res.data.file_id;
      } else {
        this.$message.error(file.name + res.msg);
      }
    },
    //上传BGM
    musicHandleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.$message.success(file.name + " 上传完成");
        this.GetMusic();
      } else {
        this.$message.error(file.name + res.msg);
      }
    },
    //试听
    playAudio() {
      if (this.voiceRadio == '') return;
      if (this.volume == 0) this.$message.warning("注意：你已设置为静音");
      let url = this.$linq.from(this.audios).firstOrDefault(w => w.audioCode == this.voiceRadio).url;
      this.$refs.audio.volume = this.volume / 100;
      this.$refs.audio.src = url;
      this.$refs.audio.play();
    },
    stopAudio() {
      this.$refs.audio.pause();
    },
    playMusic() {
      if (this.CheckRadio == '') {
        this.$message.warning("请先选择音频文件")
        return;
      };
      if (this.bgVolume == 0) this.$message.warning("注意：你已设置为静音");
      let url = this.$linq.from(this.musics).firstOrDefault(w => w.file_id == this.CheckRadio).url;
      this.$refs.audio2.volume = this.bgVolume / 100;
      this.$refs.audio2.src = url;
      this.$refs.audio2.play();
    },
    stopMusic() {
      this.$refs.audio2.pause();
    },
    //跳转
    urlto(router, params) {
      let url = router + "?" + new URLSearchParams(params).toString();
      this.$router.push(url);
    },
    //获取素材
    GetPfiles() {
      this.$get('/option/filesbypid', { productid: this.productid }).then(res => {
        this.p_files = res.data;

      });
    },
    //获取字幕
    GetSubtitles() {
      this.$get('/option/subtitle', { productid: this.productid }).then(res => {
        this.p_subtitles = res.data;
      });
    },
    // 获取BGM
    GetMusic() {
      this.$get('/music/list?size=0').then(res => {
        let musics = res.data.data;
        this.musics = musics;
        this.musics_online = this.$linq.from(musics).where(w => w.uid == 0).toArray();
        this.musics_local = this.$linq.from(musics).where(w => w.uid > 0).toArray();
      });
    },
    //选择素材
    SeletFiles() {
      this.mateCheckList.forEach(item => {
        let ids = this.$linq.from(this.files).select(s => s.file_id).toArray();
        if (ids.indexOf(item.fileId) < 0) {
          this.files.push({
            file_id: item.fileId, url: item.url, name: item.name, type: item.type, album_id: item.album_id
          });
        }
      })
      this.isMaterial = false;
    },
    //选择字幕
    SeletSubtitles() {
      this.subtitle1 = this.p_subtitles[this.templateSelection].label;
      this.isSubtitle = false;
    },
    //删除BGM
    delMusic() {
      this.$confirm('即将删除文件，是否继续？', '提示', { type: 'warning' }).then(res => {
        this.$post('/file/file_del', { file_id: this.CheckRadio }).then(res => {
          if (res.code == 200) {
            this.$message.success("删除完成");
            this.GetMusic();
          } else {
            this.$message.error("操作失败");
          }
        })
      })
    },
    del_video(index) {
      let file = this.files[index];
      if (file.album_id == 0) {
        this.$post('/file/file_del', { file_id: file.file_id }).then(res => {
          if (res.code == 200) {
            this.files.splice(index, 1)
            this.$message.success("删除完成");
          } else {
            this.$message.error("删除失败");
          }
        })
      } else {
        this.files.splice(index, 1);
        this.$message.success("删除完成");
      }
    },
    del_cover() {
      if (this.coverImageUrl.indexOf('/template/') > -1) {
        this.$message.success("删除完成");
        this.coverImageUrl = '';
      } else {
        this.$post('/file/file_del', { file_id: this.coverImageId }).then(res => {
          if (res.code == 200) {
            this.$message.success("删除完成");
            this.coverImageUrl = '';
          } else {
            this.$message.error("操作失败");
          }
        })
      }
    },

    //提交合成任务
    submit() {
      let subtitle_ok = true;
      let sub_index = 0;
      var arrStr = this.subtitle1.split("\n"); // 整个文本
      for (let index = 0; index < arrStr.length; index++) {
        let element = arrStr[index];
        if (element.length > 28) {
          sub_index = index + 1;
          subtitle_ok = false;
          break;
        }
      }

      if (subtitle_ok == false) {
        this.$confirm(`第${sub_index}行字幕过长，可点击“字幕换行”按钮换行或手动换行。`, '提示', {
          confirmButtonText: '自动换行',
          cancelButtonText: '手动换行',
          type: 'warning',
          showClose: false,
        }).then(() => {
          this.subtitleClickHandle();
        }).catch(() => {

        }).finally(() => {
          document.getElementById("subtitle1").focus();
        });
      } else {
        this.submit2();
      }
    },
    submit2() {
      let error_text = false;
      let titles = [];
      this.t_texts.forEach(group => {
        let titles_item = [];
        group.forEach(text => {
          if (text.required == true && text.value == null) {
            error_text = true; return;
          }
          titles_item.push(text.value);
        })
        titles.push(titles_item);
      });
      if (this.files.length == 0) { this.$message.error("请上传素材文件"); return; }
      if (error_text == true) { this.$message.error("请将文案填写完整"); return; }
      if (this.subtitle1 == '') {this.$message.error("需要填写字幕"); return; };
      if (this.template_code == undefined) { this.$message.error("未选择模板"); return; }
  
    

      let form_obj = {
        file_ids: this.$linq.from(this.files).select(s => s.file_id).toArray(),
        titles: titles,
        subtitle: this.subtitle1,
        audio_volume: this.volume / 100,//字幕音量
        audio: this.voiceRadio,
        font_color: this.color1,
        border_color: this.color2,
        bgimg: this.coverImageUrl,
        bgmusic_id: this.CheckRadio,
        bg_volume: this.bgVolume / 100,//bgm音量
        template_code: this.template_code,
      };
      this.$post('/clip/add', form_obj).then(res => {
        if (res.code == 200) {
          this.$message.success("添加完成");
          this.toVideoList();
        }
        else {
          this.$message.error("添加失败：" + res.msg);
        }
      })
    },
    //提交后跳转
    toVideoList() {
      this.$alert('视频制作任务已加入队列，点击“确定”跳转到视频列表等待结果。', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          location.href = '/video/list';
        }
      });
    },

  },
  mounted() {
    this.saveColor = localStorage.getItem('theme')
    if (this.saveColor == 'black') {
      this.isColor = false
    } else {
      this.isColor = true
    }
  },

  created() {
    this.platform = getPlatform();
    this.info = getUserinfo();
    this.headers = { Authorization: 'Bearer ' + localStorage.getItem('ai-token') };
    let platjson = this.$linq.from(paltform).firstOrDefault(w => w.id == this.info.plat);
    document.getElementById("icon").href = platjson.icon;

    this.template_code = this.$route.query.tcode;
    //template
    this.$get('/template/text_config', { code: this.template_code }).then(res => {
      this.t_texts = res.data;
    });
    this.$get('/template/detail', { code: this.template_code }).then(res => {
      this.template = res.data;
      this.coverImageUrl = res.data.bgimg;
    });

    //audios
    this.$get('/audio/list').then(res => {
      this.audios = res.data;
      this.voiceRadio = this.audios[0].audioCode;
    })
    //BGM
    this.GetMusic();
    //produtcs
    this.$get('/product/options?type=0').then(res => {
      this.products = res.data;
    })
    this.GetPfiles();
    this.GetSubtitles();

  }
}
</script>
<style scoped>
.subtitle-dub>>>.subtitle-text textarea {
  resize: none;
  background-color: var(--inputbgcolor);
  border: 1px solid var(--inputbordcolor);
  color: var(--maintextcolor);
  font-family: inherit;
  min-height: 100px !important;
  padding: 10px;
}

.advoice {
  display: flex;
  align-items: center;
}

.advoice .el-slider {
  width: 100%;
}

.advoice>>>.el-slider__button {
  width: 6px;
  height: 6px;
  border: 6px solid #006cff;
  background-color: #FFF;
  border-radius: 50%;
  -webkit-transition: .2s;
  transition: .2s;
  -webkit-user-select: none;
  user-select: none;
}

.advoice>>>.el-slider__runway {
  width: 100%;
  height: 6px;
  margin: 16px 0;
  background-color: #CDE7FF;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}

.advoice>>>.el-slider__bar {
  background-color: #006cff;
}

.advoice .plus-btn>>>span {
  font-size: 24px;
  color: #006cff;
  margin-left: 10px;
}

.bg-music .selector-audio>>>.el-radio-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.bg-music .selector-audio>>>.el-radio-group .el-radio {
  width: 50%;
  margin: 8px 0;
  display: inline-flex;
  align-items: center;
  color: var(--maintextcolor);
}

.bg-music .selector-audio>>>.el-radio-group .el-radio .el-radio__label {
  width: 70%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bg-music .selector-audio>>>.el-radio-group .el-radio .el-radio__inner {
  border-radius: 20%;
}

.bg-music .selector-audio>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: var(--maintextcolor);
}

.bg-music .selector-audio>>>.el-radio-group .el-radio__inner {
  background-color: #bfbfbf;
}

.bg-music .selector-audio>>>.el-radio-group .el-radio__input.is-checked .el-radio__inner {
  background-color: #006cff;
}

.bg-music .selector-audio>>>.el-radio-group .el-radio__inner::after {
  display: none;
}

.bg-music .selector-audio .foot-btn {
  margin-top: 20px;
}

.bg-music .selector-audio .foot-btn .add-btn {
  width: 110px;
}

.bg-music .selector-audio .foot-btn .remove-btn {
  width: 110px;
}

.bg-volume {
  align-items: center;
}

.bg-music .bg-con .bg-volume>span {
  margin-top: -2px;
}

.bg-music .bg-con .bg-volume>>>.el-slider__bar {
  background-color: #006cff;
}

.bg-music .bg-con .bg-volume>>>.el-slider__button {
  width: 6px;
  height: 6px;
  border: 6px solid #006cff;
  background-color: #FFF;
  border-radius: 50%;
  -webkit-transition: .2s;
  transition: .2s;
  -webkit-user-select: none;
  user-select: none;
}

.adv-scene>>>.upload-demo .el-button {
  display: flex;
  align-items: center;
}

.adv-scene>>>.upload-demo .el-button span {
  color: #fff;
}

.mat-dialog .mate-grop .mate-grop-item .mate-grop-check>>>.el-checkbox__inner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0);
  /* 修改 */
  border: 2px solid #d9dde5;
  display: block !important;
}

.mat-dialog .mate-grop .mate-grop-item .mate-grop-check>>>.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #006cff;
  border: 2px solid #006cff;

}

.mat-dialog .mate-grop .mate-grop-item .mate-grop-check>>>.el-checkbox__label {
  display: none;
}

.mat-dialog .mate-grop>>>.el-dialog {
  height: 500px !important;
}

.mat-dialog>>>.el-dialog {
  background-color: var(--mainbgcolor);
}

.mat-dialog>>>.el-dialog .el-dialog__body {
  height: 400px;
  overflow-y: auto;
  box-sizing: border-box;
}

.mat-dialog>>>.el-dialog .el-dialog__title {
  color: var(--maintextcolor);
}

.mat-dialog>>>.el-dialog .dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mat-dialog>>>.el-dialog .el-dialog__footer {
  padding: 20px 20px;
}

.mat-dialog>>>.el-dialog .dialog-footer .el-button {
  background-color: #006cff;
  padding: 10px 20px;
  border: #006cff;
}

.mat-dialog>>>.el-dialog .el-dialog__close {
  color: var(--maintextcolor);
}

.mate-grop::-webkit-scrollbar {
  width: 8px;
}

.mate-grop::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px var(--maintextcolor);
  background: var(--maintextcolor);
}

.mate-grop::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.mat-select {
  position: absolute;
  left: 50%;
  top: 12px;
  transform: translateX(-50%);
}

.mat-select>>>.el-input__inner {
  height: 35px;
  line-height: 35px;
}

.el-button {
  opacity: 1;
  transition: all 0.2s ease;
}

.el-button:hover {
  opacity: 0.8;
}

.el-button:focus {
  opacity: 0.8;
  border: 1px solid #006cff;
}
</style>
